import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner
} from '../../config/react'
import DataTable from 'react-data-table-component'

const ProductAttributeSet = () => {
  const [SizeList, setSizeList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  const columns = [
    {
      name: 'Name',
      sortable: true,
      sortField: 'name',
      selector: (row) => row.name
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/attribute/attributeset/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => {
              if (row.is_product_exist) {
                e.preventDefault()
              } else {
                DeleteProductAttributeSet(e, row.id)
              }
            }}
            to=""
            className={row.is_product_exist ? 'text-dark disabled' : 'text-dark'}
            title={row.is_product_exist ? Messages.ProductAttributeSetDeleteError : 'Delete'}
            disabled={row.is_product_exist}
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.ProductAttributeSet
    GetProductAttributeSetList()
  }, [CustomFilters])

  const GetProductAttributeSetList = () => {
    const passData = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    // console.log('LN 65 Page '+CustomFilters.page+' &page_size '+CustomFilters.page_size);
    setLoading(true)
    HttpService.postApi(API.GetProductAttributeSetAdminList, passData).then((response) => {
      setLoading(false)
      // setSizeList(response.data.result[0])
      if (response.data.status === true) {
        const data = response.data.result[1]
        setSizeList(data)
        settotalRows(response.data.result[0][0].total_row)
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
    // console.log('LN 85 Page 1'+' &page_size '+e);
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Name."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setCustomFilters({ ...CustomFilters, page: currentPage, search: e.target.value })
        }
      />
    )
  })

  const DeleteProductAttributeSet = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true,
          Userid: user.id
        }
        // console.log(param);
        setLoading(true)
        HttpService.postApi(API.DeleteProductAttributeSet, param).then((response) => {
          setLoading(false)
          // console.log(response);
          toast.success(Messages.RecordDeleted)
          GetProductAttributeSetList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }
  const handleSort = (e, direction) => {
    // console.log('LN 115 Sort FIeld ' + e.sortField);
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.ProductAttributeSet} </h3>
        <div className="btn-group">
          <Link
            to="/attribute/attributeset/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.AddProductAttributeSet}{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={SizeList}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductAttributeSet
